import { render, staticRenderFns } from "./modalCreateCustomerFromPotential.vue?vue&type=template&id=38fa40b4&"
import script from "./modalCreateCustomerFromPotential.vue?vue&type=script&lang=js&"
export * from "./modalCreateCustomerFromPotential.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports